export default "__VITE_ASSET__BnJnVCOw__"